import React, {Component} from 'react'
import {withRouter} from "react-router-dom";
import NewClaimMenu from "./newClaimMenu";
import {Button, Divider, Grid, Header, Icon, Image, Table} from "semantic-ui-react";
import NewClaimSteps from "./newClaimSteps";
import "./newClaims.css"
import {removeFile} from "../../../actions/newClaimActions";
import {connect} from "react-redux";
import {cropText, getNumberOfUploadsRequired} from "../../../utils/common";
import Footer from "../../footer";
import {Document, Page, pdfjs} from "react-pdf";
import {MAX_FILES_AMOUNT} from "../../../utils/constants";
import {ClaimStepsLayout} from "../claimStepsLayout";
import {ClickableText} from "../../custom-common";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        claimant: state.newClaim.claimant,
        files: state.newClaim.files,
        treatmentInfo: state.newClaim.treatmentInfo,
        userIsCertificateHolder: state.initialData.userIsCertificateHolder
    }
};

class ConfirmUploads extends Component {
    constructor(props) {
        super(props);
        const {claimant} = this.props;
        if (!claimant) {
            console.warn("No user info")
            this.props.history.replace("/claims");
        }
    }

    onBackHandler = () => {
        this.props.history.replace("/claims/new/uploads");
    }

    onNext = () => {
        if (!!this.props.userIsCertificateHolder) {
            this.props.history.push("/claims/new/payment")
        } else {
            this.props.history.push("/claims/new/review")
        }
    }

    removeFile = (index) => {
        this.props.dispatch(removeFile(index))
    }

    render() {
        const {files} = this.props;
        const button = <Button primary content="Next step" onClick={this.onNext}/>
        const numberOfUploadsRequired = getNumberOfUploadsRequired(this.props.treatmentInfo)

        return (
            <React.Fragment>
                <NewClaimMenu onBack={this.onBackHandler}/>
                <ClaimStepsLayout>
                    <NewClaimSteps activeStepIdx={1}/>
                    <div style={{marginTop: "56px"}}>
                    <Grid container stackable columns={1} centered>
                        <Grid.Column width={8} className={"pageContent"}>
                            <Header as={"h2"}>Confirm uploads</Header>

                            {(!!files && files.length > 0) && <Table basic={"very"} unstackable>
                                <Table.Body>
                                    <Table.Row>
                                        <td><b>Preview</b></td>
                                        <td><b>Name</b></td>
                                        <Table.Cell textAlign={"center"}><b>Status</b></Table.Cell>
                                        <td><b></b></td>
                                    </Table.Row>
                                    {files.map((file, index) => {
                                        const isAcceptedFile = file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "application/pdf"
                                        return (
                                            <Table.Row key={index}>
                                                <Table.Cell>
                                                    {isAcceptedFile ?
                                                        file.type.startsWith("image/") ?
                                                            <div style={{height: '56px', width: '75px'}}>
                                                                <Image centered
                                                                    bordered
                                                                    style={{
                                                                        objectFit: 'cover',
                                                                        height: '100%',
                                                                        width: '100%'
                                                                    }}
                                                                    src={file.url} />
                                                            </div> :
                                                            (file.type === "application/pdf" ?
                                                                <div style={{height: '56px', width: '75px', border: '1px solid rgba(0, 0, 0, 0.1)', overflow: 'hidden'}}>
                                                                <Document
                                                                    file={file.url}
                                                                ><Page pageNumber={1} width={73}/></Document></div> :
                                                                <div style={{
                                                                    height: '56px',
                                                                    width: '72px',
                                                                    border: '1px solid #999999',
                                                                    display: 'table-cell',
                                                                    verticalAlign: 'middle', textAlign: 'center'
                                                                }}>
                                                                    <Icon name="file outline"/>
                                                                </div>)
                                                        :
                                                        <div style={{
                                                            height: '56px',
                                                            width: '75px',
                                                            border: '1px solid #D82000',
                                                            display: 'table-cell',
                                                            verticalAlign: 'middle', textAlign: 'center'
                                                        }}><Icon name="warning sign" color={"red"}/></div>
                                                    }

                                                </Table.Cell>
                                                <Table.Cell>
                                                    {cropText(file.name, 45)}
                                                </Table.Cell>
                                                <Table.Cell textAlign={"center"} verticalAlign={"middle"}><Icon name="check"/></Table.Cell>
                                                <Table.Cell textAlign={"right"} verticalAlign={"middle"}>
                                                    {/*<Dropdown trigger={trigger}>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item text='Remove' />
                                                        </Dropdown.Menu>
                                                    </Dropdown>*/}
                                                    <Icon color={"grey"} link onClick={()=>{this.removeFile(index)}} name={"trash alternate outline"}/>
                                                </Table.Cell>
                                            </Table.Row>
                                        )
                                    })
                                    }
                                </Table.Body>
                            </Table>}
                            {files.length < MAX_FILES_AMOUNT ? (
                                <ClickableText onClick={this.onBackHandler}>+ Upload more</ClickableText>
                            ) : (
                                <p className="neutral700" style={{fontStyle: 'italic', marginTop: '1em'}}>
                                    You've reached the maximum number of uploads ({MAX_FILES_AMOUNT}).
                                </p>
                            )}
                        </Grid.Column>
                    </Grid>
                    </div>
                    <Grid container stackable columns={1} centered style={{alignItems: 'flex-end', flex: 1}}>
                        {(files.length < numberOfUploadsRequired) && <Grid.Column width={8} className={"pageContent"}>
                                <p><b>Note:</b> We would ideally like {numberOfUploadsRequired} documents submitted, submitting a claim with less
                                    than that can lead to longer claim review timelines.</p>
                            <Divider hidden/>
                            </Grid.Column>}
                    </Grid>
                    <div style={{marginTop: "100px"}}>
                        <Footer showTopFooter={true} hasToDisplayCarrierDisclaimer
                                button={button}
                        />
                    </div>
                </ClaimStepsLayout>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps)(withRouter(ConfirmUploads));
